module.exports = __webpack_public_path__ + "img/mm.7dc3483d.svg";